import React from 'react';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  return <section className="py-[50px] px-[15px] relative bg-cover bg-center bg-[url('https://app.heylloyd.io/public/files/openrouter-generated-image-1770512736972.png')]" data-id="element-163">
      <div className="absolute inset-0 bg-gradient-to-t from-[rgba(0,0,0,0.7)] via-[rgba(0,0,0,0.3)] to-[rgba(0,0,0,0.7)] z-[1]" data-id="element-164"></div>
      <div className="container max-w-full mx-auto px-[15px] relative z-[2]" data-id="element-165">
        <div className="bg-gradient-to-r from-[#8B4513] to-[#654321] text-white p-[12px_20px] text-center font-[700] text-[18px] uppercase rounded-[8px] mb-[25px] shadow-[0_5px_15px_rgba(139,69,19,0.3)] w-full" data-id="element-166">
          Son las 7:12 AM. Ponés agua. Molés. Hacés "lo de siempre".
        </div>

        <div className="flex gap-[15px] mb-[15px] p-[15px] border-l-[4px] border-[#8B4513] bg-[rgba(255,255,255,0.85)] shadow-[0_4px_10px_rgba(0,0,0,0.05)] rounded-[6px]" data-id="element-167">
          <XCircle className="text-[#EF4444] text-[20px] mt-[3px] flex-shrink-0" data-id="element-168" />
          <div data-id="element-169">
            Probás… y otra vez no. No es que sea horrible.{' '}
            <strong data-id="element-170">Es peor: es impredecible.</strong>
          </div>
        </div>

        <div className="flex gap-[15px] mb-[15px] p-[15px] border-l-[4px] border-[#8B4513] bg-[rgba(255,255,255,0.85)] shadow-[0_4px_10px_rgba(0,0,0,0.05)] rounded-[6px]" data-id="element-171">
          <XCircle className="text-[#EF4444] text-[20px] mt-[3px] flex-shrink-0" data-id="element-172" />
          <div data-id="element-173">
            Un día sale bien. Al otro sale agrio. Al otro, amargo.{' '}
            <strong data-id="element-174">Y empieza el diálogo interno.</strong>
          </div>
        </div>

        <div className="flex gap-[15px] mb-[15px] p-[15px] border-l-[4px] border-[#8B4513] bg-[rgba(255,255,255,0.85)] shadow-[0_4px_10px_rgba(0,0,0,0.05)] rounded-[6px]" data-id="element-175">
          <XCircle className="text-[#EF4444] text-[20px] mt-[3px] flex-shrink-0" data-id="element-176" />
          <div data-id="element-177">
            — ¿Será el café? — ¿Será el molinillo? — ¿Será el agua? —{' '}
            <strong data-id="element-178">¿Será que no sirvo para esto?</strong>
          </div>
        </div>

        <div className="flex gap-[15px] mb-[15px] p-[15px] border-l-[4px] border-[#8B4513] bg-[rgba(255,255,255,0.85)] shadow-[0_4px_10px_rgba(0,0,0,0.05)] rounded-[6px]" data-id="element-179">
          <XCircle className="text-[#EF4444] text-[20px] mt-[3px] flex-shrink-0" data-id="element-180" />
          <div data-id="element-181">
            No estás fallando por falta de ganas.{' '}
            <strong data-id="element-182">
              Estás fallando porque nadie te dio un método que puedas repetir y
              diagnosticar.
            </strong>
          </div>
        </div>
      </div>
    </section>;
}